import utils from '../../utils';
const { loadJSScript } = utils;

const HEAP_IO_IDENTIFY_MAX_LENGTH = 225;

class HeapClient {
    /**
     * New a heap io client.
     * Please don't use this constructor external.
     * We should use getInstance to ensure we use a single instance.
     * @param appId
     */
    constructor(appId) {
        if (appId && typeof appId === 'string') {
            if (!window.heap) {
                _initHeap();
                // Set app id.
                window.heap.load(appId);
            }
        } else {
            throw new Error('Must set the app id for heap io client.');
        }
    }

    /**
     * Get the single instance.
     * @param appId - heap io app id.
     * @returns {HeapClient} heap client.
     */
    static getInstance(appId) {
        if (!this.instance) {
            this.instance = new HeapClient(appId);
        }
        return this.instance;
    }

    /**
     * Heap io track api.
     * @param name - the event name.
     * @param content - the content obj.
     */
    track(name, content) {
        if (typeof name === 'string' && name) {
            window.heap.track(name, content);
        } else {
            // TODO: We should print the log.
        }
    }

    setIdentify(value) {
        if (
            typeof value === 'string' &&
            value &&
            [...value].length < HEAP_IO_IDENTIFY_MAX_LENGTH
        ) {
            window.heap.identify(value);
        } else {
            // TODO: We should print the log.
        }
    }

    addUserProperty(name, value) {
        if (typeof name === 'string' && name) {
            window.heap.addUserProperties({ [name]: value });
        } else {
            // TODO: We should print the log.
        }
    }
}

function _initHeap() {
    const heapApis = [
        'addEventProperties',
        'addUserProperties',
        'clearEventProperties',
        'identify',
        'resetIdentity',
        'removeEventProperty',
        'setEventProperties',
        'track',
        'unsetEventProperty'
    ];
    window.heap = window.heap || [];
    window.heap.load = function(appId, config) {
        window.heap.appid = appId;
        window.heap.config = config = config || {};
        const needSSL =
            config.forceSSL || 'https:' === document.location.protocol;
        const src = `${
            needSSL ? 'https:' : 'http:'
        }//cdn.heapanalytics.com/js/heap-${appId}.js`;
        // Load heap io js file.
        loadJSScript(src);
        const generateApiByName = function(apiName) {
            return function() {
                window.heap.push(
                    [apiName].concat(Array.prototype.slice.call(arguments, 0))
                );
            };
        };
        for (let i = 0; i < heapApis.length; i++) {
            const apiName = heapApis[i];
            window.heap[apiName] = generateApiByName(apiName);
        }
    };
}

export default HeapClient;
